module.exports = __webpack_public_path__ + "fonts/ea8a15b70fcaf74075a09facb5670146.svg";